import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getCandidatesApi } from "../../API/API";

function* getCandidatesSaga(params) {
  try {
    const response = yield call(getCandidatesApi, params);
    yield put({
      type: types.GET_CANDIDATES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_CANDIDATES_FAILURE, error });
  }
}

export function* watchGetCandidatesSaga() {
  yield takeEvery(types.GET_CANDIDATES_REQUESTED, getCandidatesSaga);
}
